// The guided page's kinds (spec ui-perf/simple-studio) and its path, `simple/make` (spec
// ui-perf/simple-home): one list for its search and for the old links that name a kind.

export const GUIDED_KINDS = ["image", "video", "ad"] as const;
export type GuidedKind = (typeof GUIDED_KINDS)[number];

/** One of the guided page's kinds; anything else names none. */
export function isGuidedKind(value: unknown): value is GuidedKind {
  return typeof value === "string" && (GUIDED_KINDS as readonly string[]).includes(value);
}

/** A brand's Simple root, with or without its last slash, and nothing under it. */
const SIMPLE_ROOT = /^\/teams\/[^/]+\/brands\/[^/]+\/simple\/?$/;

/**
 * Where a link goes that names a guided kind at Simple's root, from before Home was Simple's
 * (`simple?kind=`, `home2/simple?kind=`): the guided page, `simple/make`. Any other path is its own.
 */
export function guidedPath(pathname: string, search: { kind?: unknown }): string {
  if (!isGuidedKind(search.kind) || !SIMPLE_ROOT.test(pathname)) return pathname;
  return `${pathname.replace(/\/$/, "")}/make`;
}
